import BlueCards from "../components/BlueCards";
import './Services.css'

function Services()
{
    return(
<div className="service_container">
    <h1>Our Services</h1>
    <h3>Comprehensive IT solutions designed to accelerate your business growth and keep you ahead of the competition.</h3>
    <BlueCards/>
</div>
    );
}
export default Services;